import { Autocomplete } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Form, Formik, FormikErrors } from "formik";
import * as React from "react";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import EditButton from "../../components/Buttons/EditButton";
import ErrorMsg from "../../components/ErrorMsg";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import {
  useGetResourceTypesQuery,
  useModifyResAssMutation,
} from "../../services/appln";

interface FormData {
  resourceTypeId: string;
  count: string;
}

interface Props {
  bandobastId: string;
  timeslotId: string;
  locationId: string;
  resourceAssessmentId: string;
  initialValues: any;
}

export default function EditResourceAssessment(props: Props) {
  console.log("EditResourceAssessment, props:", props);

  const [modifyResourceAssessment, modifyResourceAssessmentParams] =
    useModifyResAssMutation();

  const resourceTypeData = useGetResourceTypesQuery(null);
  const resourceTypeMap = new Map<string, string>();
  resourceTypeData.data?.data.forEach((element: any) => {
    resourceTypeMap.set(element.name, element.id);
  });

  const initialValues: FormData = {
    resourceTypeId: props.initialValues.resourceTypeName,
    count: props.initialValues.count,
  };

  const [dialogOpen, setDialogOpen] = React.useState(false);

  console.log(
    "EditResourceAssessment, modifyPersonnelAssessmentParams:",
    modifyResourceAssessmentParams,
  );
  React.useEffect(() => {
    if (modifyResourceAssessmentParams.isSuccess) {
      setDialogOpen(false);
    }
  }, [modifyResourceAssessmentParams]);

  return (
    <div>
      <EditButton
        onClickHandler={() => {
          setDialogOpen(true);
        }}
      />
      <Dialog
        open={dialogOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {strings.editResourceAssessment}
        </DialogTitle>
        {modifyResourceAssessmentParams.isError && (
          <ErrorMsg msg={strings.failedToEditPersonnelAssessment} />
        )}
        {modifyResourceAssessmentParams.isLoading && <ProgressIndicator />}
        <DialogContent>
          <Formik
            initialValues={initialValues}
            validate={(values) => {
              const errors: FormikErrors<FormData> = {};
              if (!values.resourceTypeId) {
                errors.resourceTypeId = strings.resourceTypeMandatory;
              }
              if (!values.count) {
                errors.count = strings.countMandatory;
              } else {
                const countVal = parseInt(values.count);
                if (isNaN(countVal)) {
                  errors.count = strings.countShouldBeNumber;
                }
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              const valuesClone = { ...values };
              valuesClone.resourceTypeId = resourceTypeMap.get(
                values.resourceTypeId!,
              )!;
              console.log(
                "EditResourceAssessment, values after modification",
                valuesClone,
              );
              setSubmitting(false);
              modifyResourceAssessment({
                bandobastId: props.bandobastId,
                locationId: props.locationId,
                resourceAssessmentId: props.resourceAssessmentId,
                body: valuesClone,
              });
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={9}>
                      <Autocomplete
                        fullWidth
                        disablePortal
                        id="resourceTypeId"
                        defaultValue={values.resourceTypeId}
                        options={Array.from(resourceTypeMap.keys())}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            margin="normal"
                            required
                            label={strings.resourceType}
                          />
                        )}
                        onChange={(e, value: any) => {
                          console.log(value);
                          setFieldValue("resourceTypeId", value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        id="count"
                        name="count"
                        label={strings.count}
                        value={values.count}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.count && Boolean(errors.count)}
                        helperText={touched.count && errors.count}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ButtonGroup>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {strings.save}
                        </Button>
                        <Button
                          variant="contained"
                          onClick={() => {
                            setDialogOpen(false);
                          }}
                        >
                          {strings.cancel}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
